import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  ModalFooter,
  Button,
} from '@televet/kibble-ui';
import React from 'react';

interface IConfirmPaymentModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  modalText: string;
}

const ConfirmPaymentModal = ({ isOpen, onClose, onConfirm, modalText }: IConfirmPaymentModalProps): JSX.Element => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="sm">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Are you sure? </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text size="md">{modalText}</Text>
        </ModalBody>
        <ModalFooter justifyContent="space-between">
          <Button size="md" variant="tertiary" mr={3} onClick={onClose}>
            No
          </Button>
          <Button size="md" onClick={onConfirm}>
            Yes
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ConfirmPaymentModal;
